import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChild,
  RouterStateSnapshot
} from '@angular/router';
import { AllFeatureFlags } from '@models/mmobile';
import { PatrimonialsRoute } from '../../models/patrimonial';
import { isServeMode } from '../../utils/utils';
import { ContextService } from '../core/context.service';
import { MMobileHelperService } from '../core/mmobile-helper.service';
import { NavigationHelper } from '../core/navigation-helper.service';

@Injectable({
  providedIn: 'root'
})
export class PwaAccessGuard implements CanActivateChild {
  constructor(
    private nav: NavigationHelper,
    private mmobileHelper: MMobileHelperService,
    private ctx: ContextService
  ) {}

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    { url }: RouterStateSnapshot
  ) {
    if (this.ctx.isApp || isServeMode()) {
      return true;
    }
    const onlyPatrimonialAllowed =
      this.mmobileHelper.checkIsFeatureEnabled(AllFeatureFlags.PWA_ACCESS_BLOCKED) || false;
    const isUrlFromPatrimonial =
      url.includes(PatrimonialsRoute.PUBLIC_ROUTE) ||
      url.includes(PatrimonialsRoute.REPORT_PROCCESS_ROUTE);
    if (onlyPatrimonialAllowed && !isUrlFromPatrimonial) {
      this.nav.toNew(PatrimonialsRoute.PUBLIC_ROUTE);
    }

    return true;
  }
}
